import { render } from "./PostSnippet.vue?vue&type=template&id=4f5df1eb&scoped=true"
import script from "./PostSnippet.vue?vue&type=script&lang=js"
export * from "./PostSnippet.vue?vue&type=script&lang=js"

import "./PostSnippet.vue?vue&type=style&index=0&id=4f5df1eb&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f5df1eb"]])

export default __exports__